// extracted by mini-css-extract-plugin
export default {"mainContainer":"wordle_mainContainer__YrbEH","box":"wordle_box__RYNI5","row":"wordle_row__DEvaG"};